import React from "react";

import { Container, Input, Label, Slider, InnerContainer } from "./styles";

function Tab({ titles }) {
  if (!titles || titles.length === 0) {
    return <></>;
  }

  return (
    <Container titlesLength={titles.length}>
      <InnerContainer>
        {titles.map((title, index) => (
          <React.Fragment key={title.header}>
            <Input
              onChange={title.onPress}
              type="radio"
              id={`r${index + 1}`}
              name="t"
              checked={title.pressed}
            />
            <Label htmlFor={`r${index + 1}`} checked={title.pressed}>{title.header}</Label>
          </React.Fragment>
        ))}
        <Slider id="slider" titlesLength={titles.length} />
      </InnerContainer>
    </Container>
  );
}

export default Tab;
